import React from "react";
import "./App.css";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "./contexts/AuthContext";
import { CartProvider } from "./contexts/CartContext";
import { hit } from "./lib/metrika";

import Header from "./components/Header";
import Footer from "./components/Footer";
import CartSidebar from "./components/CartSidebar";

import Home from "./pages/Home";
import About from "./pages/About";
import Delivery from "./pages/Delivery";
import Contacts from "./pages/Contacts";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import PirogiNaZakaz from "./pages/PirogiNaZakaz";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

const Layout = ({ children }) => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  const didMountRef = React.useRef(false);

  React.useEffect(() => {
    if (didMountRef.current) {
      hit(window.location.href);
      return;
    }

    didMountRef.current = true;
  }, [pathname]);

  return (
    <>
      {!isAdmin && <Header />}
      {isAdmin && (
        <header className="border-b border-[#E8E3DA] bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex items-center justify-between">
            <a href="/" className="font-display text-xl text-[#2C2520]" data-testid="admin-header-home">
              Ишеевские пироги · <span className="text-[#C65D3B]">админ</span>
            </a>
          </div>
        </header>
      )}
      {children}
      {!isAdmin && <Footer />}
      {!isAdmin && <CartSidebar />}
    </>
  );
};

function App() {
  return (
    <div className="App">
      <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/o-kompanii/" element={<About />} />
                <Route path="/dostavka-pirogov-ulyanovsk/" element={<Delivery />} />
                <Route path="/kontakty/" element={<Contacts />} />
                <Route path="/pirogi-na-zakaz/" element={<PirogiNaZakaz />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/blog/1" element={<Navigate to="/blog/kak-zakazat-pirogi-s-dostavkoy-ulyanovsk" replace />} />
                <Route path="/blog/2" element={<Navigate to="/blog/pominalnye-pirogi-s-dostavkoy-ulyanovsk" replace />} />
                <Route path="/blog/3" element={<Navigate to="/blog/svadebnyy-karavay-ulyanovsk-traditsii-i-kak-zakazat" replace />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/about" element={<Navigate to="/o-kompanii/" replace />} />
                <Route path="/delivery" element={<Navigate to="/dostavka-pirogov-ulyanovsk/" replace />} />
                <Route path="/contacts" element={<Navigate to="/kontakty/" replace />} />
              </Routes>
            </Layout>
            <Toaster
              position="bottom-right"
              theme="light"
              richColors
              closeButton
            />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
